import React, { useEffect, useState } from 'react';
import { Grid, TextField, useMediaQuery, useTheme } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { Controller, useForm } from 'react-hook-form';
import { theme } from 'theme';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { SdmTypography } from 'components/SdmTypography';
import { SdmSpacer } from 'components/SdmSpacer';
import { SdmSelect } from 'components/SdmSelect';
import { SdmTextButton } from 'components/SdmTextButton';
import { format } from 'date-fns';
import { SdmCheckbox } from 'components/SdmCheckbox';
const CustomFormTextField = withStyles({
  root: {
    width: '90%',
    '& .MuiFormControl-root': {
      width: '95%',
    },
    '& label.Mui-focused': {
      color: `${theme.colors.primary.black}`,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: `${theme.colors.primary.black}`,
    },
    '& .MuiInput-underline:before': {
      borderBottom: `2px solid ${theme.colors.primary.black}`,
    },
    '& .MuiInputBase-input': {
      fontFamily: 'Suisse-Intl',
      fontSize: 26,
    },
    '& .MuiFormLabel-root': {
      fontFamily: 'Suisse-Intl',
      color: `${theme.colors.primary.black}`,
      fontSize: 21,
    },
    '& .MuiInput-formControl.MuiInputBase-multiline.MuiInput-multiline': {
      lineHeight: 1,
    },
  },
})(TextField);

const defaultValue = {
  id: undefined,
  brandName: undefined,
  date: undefined,
  time: undefined,
  language: undefined,
  givenName: undefined,
  familyName: undefined,
  email: undefined,
  phone: undefined,
  company: undefined,
  reason: undefined,
};

const BookingUser = ({ onBack, exhibitor, user, onSubmit, fetchedUser }) => {
  // Hooks
  const intl = useIntl();
  const i18n = translations.Agenda(intl).forms;
  const i18nPrivacy = translations.Tickets(intl).edit.ticketEditCard.fields;
  const mediaTheme = useTheme();
  const isSmDown = useMediaQuery(mediaTheme.breakpoints.down('sm'));
  // Hooks
  const { handleSubmit, errors, control, watch, setValue } = useForm({
    defaultValues: defaultValue,
  });

  const [dates, setDates] = useState([]);
  const [visits, setVisits] = useState([]);
  const [times, setTimes] = useState([]);
  const [checkValue, setCheckValue] = useState(false);

  useEffect(() => {
    // .slots.items
    const _v = exhibitor.data.visits.items.filter(
      (v) => !!v?.slots?.items?.length
    );
    setVisits(_v);
    const _dates = exhibitor.data.visits.items
      .filter((v) => !!v?.slots?.items?.length)
      .sort((a, b) => new Date(a.date) - new Date(b.date))
      .map((d) => ({
        value: d.date,
        label: format(new Date(d.date), 'dd-MM-yyyy'),
        id: d.id,
      }));
    setDates(_dates);
  }, [exhibitor]);

  // Functions
  const customSubmit = (data) => {
    if (!checkValue) return null;
    onSubmit && onSubmit(data);
  };
  const handleBack = () => onBack?.();

  const languages = [
    { value: 'it', label: i18n.fields.languages.it },
    { value: 'en', label: i18n.fields.languages.en },
    { value: 'fr', label: i18n.fields.languages.fr },
    { value: 'ru', label: i18n.fields.languages.ru },
    { value: 'ch', label: i18n.fields.languages.ch },
    { value: 'de', label: i18n.fields.languages.de },
  ];

  const selectedDate = watch('date');

  // Renders
  const renderError = (key) => {
    if (errors[key] && errors[key]?.type === 'required') {
      return (
        <SdmTypography
          style={{ color: `${theme.colors.primary.red}`, marginTop: -0 }}
          variant={'textBold'}
        >
          {i18n.fields.error}
        </SdmTypography>
      );
    }
    return null;
  };
  return (
    <form onSubmit={handleSubmit(customSubmit)}>
      <Grid container>
        <Grid item xs={12}>
          <SdmTypography variant={'h1Regular'} margin={0}>
            {i18n.userSettings}
          </SdmTypography>
        </Grid>
        <SdmSpacer height={isSmDown ? 20 : 30} />
        <Grid item md={6} sm={6} xs={12}>
          <Controller
            name={'brandName'}
            control={control}
            defaultValue={exhibitor.nomeEspositore}
            rules={{ required: true }}
            render={(props) => (
              <CustomFormTextField
                onChange={(e) => {
                  props.onChange(e.target.value);
                }}
                value={exhibitor.nomeEspositore}
                id={`brand-required`}
                label={`${i18n.fields.brand}`}
                style={{ marginBottom: 10 }}
                disabled={true}
              />
            )}
          />
          {renderError('brand')}
        </Grid>
        <Grid item md={6} sm={6} xs={false} />
        <Grid item md={6} sm={6} xs={12}>
          <SdmTypography variant={'text'} margin={0}>
            {i18n.fields.date}
          </SdmTypography>
          <Controller
            name="date"
            control={control}
            rules={{ required: true }}
            render={(props) => {
              return (
                <SdmSelect
                  options={dates}
                  value={props.value}
                  labelKey={'label'}
                  label={i18n.fields.date}
                  onSelect={(e) => {
                    props.onChange(e);
                    const visitSelected = visits.find((v) => v.id === e.id);
                    const slots = visitSelected.slots.items
                      .filter(
                        (s) =>
                          s.occupants?.items?.length < parseInt(s.slotCapacity)
                      )
                      .sort((a, b) => new Date(a.start) - new Date(b.start))
                      .map((s) => ({
                        label: `${format(new Date(s.start), 'HH:mm')}-${format(
                          new Date(s.end),
                          'HH:mm'
                        )}`,
                        value: s.id,
                      }));
                    setTimes(slots);
                    setValue('time', { label: undefined, value: undefined });
                  }}
                  customStyle={{ width: '90%', marginLeft: 0 }}
                />
              );
            }}
          />
          {renderError('date')}
        </Grid>
        {selectedDate ? (
          <Grid item md={6} sm={6} xs={12}>
            <SdmTypography variant={'text'} margin={0}>
              {i18n.fields.time}
            </SdmTypography>
            <Controller
              name="time"
              control={control}
              rules={{ required: true }}
              defaultValue={''}
              render={(props) => {
                return (
                  <SdmSelect
                    options={times}
                    value={props.value}
                    labelKey={'label'}
                    label={i18n.fields.time}
                    onSelect={(e) => {
                      props.onChange(e);
                    }}
                    customStyle={{ width: '90%', marginLeft: 0 }}
                    disabled={!selectedDate}
                  />
                );
              }}
            />
            {renderError('time')}
          </Grid>
        ) : (
          <Grid item md={6} sm={6} xs={false} />
        )}
        <Grid item xs={12}>
          <SdmTypography variant={'text'} margin={0}>
            {i18n.fields.language}
          </SdmTypography>
          <Controller
            name="language"
            control={control}
            rules={{ required: true }}
            defaultValue={languages[0]}
            render={(props) => {
              return (
                <SdmSelect
                  options={languages}
                  value={props.value || languages[0]}
                  labelKey={'label'}
                  label={i18n.fields.language}
                  onSelect={(e) => {
                    props.onChange(e);
                  }}
                  customStyle={{ width: '95%', marginLeft: 0 }}
                />
              );
            }}
          />
          {renderError('language')}
        </Grid>
        <SdmSpacer height={isSmDown ? 5 : 10} />
        <Grid item md={6} sm={6} xs={12}>
          <Controller
            name={'givenName'}
            control={control}
            defaultValue={user.givenName}
            rules={{ required: true }}
            render={(props) => (
              <CustomFormTextField
                onChange={(e) => {
                  props.onChange(e.target.value);
                }}
                value={user.givenName}
                label={`${i18n.fields.givenName}`}
                style={{ marginBottom: 10 }}
                disabled={true}
              />
            )}
          />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Controller
            name={'familyName'}
            control={control}
            defaultValue={user.familyName}
            rules={{ required: true }}
            render={(props) => (
              <CustomFormTextField
                onChange={(e) => {
                  props.onChange(e.target.value);
                }}
                value={user.familyName}
                label={`${i18n.fields.familyName}`}
                style={{ marginBottom: 10 }}
                disabled={true}
              />
            )}
          />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Controller
            name={'email'}
            control={control}
            defaultValue={user.email}
            rules={{ required: true }}
            render={(props) => (
              <CustomFormTextField
                onChange={(e) => {
                  props.onChange(e.target.value);
                }}
                value={user.email}
                label={`${i18n.fields.email}`}
                style={{ marginBottom: 10 }}
                disabled={true}
              />
            )}
          />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Controller
            name={'phone'}
            control={control}
            defaultValue=""
            rules={{ required: true }}
            render={(props) => (
              <CustomFormTextField
                onChange={(e) => {
                  props.onChange(e.target.value);
                }}
                value={props.value}
                label={`${i18n.fields.phone}*`}
                style={{ marginBottom: 10 }}
              />
            )}
          />
          {renderError('phone')}
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Controller
            name={'company'}
            control={control}
            defaultValue={
              fetchedUser?.ragioneSociale ? fetchedUser?.ragioneSociale : ''
            }
            rules={{ required: true }}
            render={(props) => (
              <CustomFormTextField
                onChange={(e) => {
                  props.onChange(e.target.value);
                }}
                value={
                  fetchedUser?.ragioneSociale
                    ? fetchedUser?.ragioneSociale
                    : props.value
                }
                label={`${i18n.fields.company}*`}
                style={{ marginBottom: 10 }}
                disabled={fetchedUser?.ragioneSociale}
              />
            )}
          />
          {renderError('company')}
        </Grid>
        <SdmSpacer height={isSmDown ? 20 : 60} />
        <Grid item xs={12}>
          <SdmSpacer height={5} />
          <Controller
            name="reason"
            control={control}
            rules={{ required: true }}
            defaultValue=""
            render={(props) => (
              <CustomFormTextField
                onChange={(e) => {
                  props.onChange(e.target.value);
                }}
                value={props.value}
                label={`${i18n.fields.reasonUser}*`}
                style={{ marginBottom: 10, width: '95%' }}
                multiline
                rows={7}
                maxRows={Infinity}
              />
            )}
          />
          {renderError('reason')}
        </Grid>
        <SdmSpacer height={isSmDown ? 10 : 20} />
        <Grid item md={9} sm={9} xs={12}>
          <SdmCheckbox
            onChange={() => {
              setCheckValue((prev) => !prev);
            }}
            value={checkValue}
            isSelected={checkValue}
            label={i18nPrivacy.owner_flag_privacy_1.label}
            labelPlacement={'end'}
            customFont={'text'}
            style={{ marginLeft: 20 }}
          />
        </Grid>

        <SdmSpacer height={isSmDown ? 10 : 50} />
        <Grid item xs={12}>
          <SdmSpacer height={isSmDown ? 50 : 80} />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: isSmDown ? 'center' : 'flex-end',
              marginRight: isSmDown ? 0 : 50,
            }}
          >
            <SdmTextButton
              onClick={handleBack}
              text={i18n.fields.buttons.back}
              height={30}
              style={{ width: 158, height: 50, marginRight: 10 }}
              variant={'red'}
              textVariant={'h4Regular'}
            />
            <SdmTextButton
              text={i18n.fields.buttons.send}
              height={30}
              type={'submit'}
              style={{ width: 158, height: 50, marginLeft: 10 }}
              variant={'redFill'}
              textVariant={'h4Regular'}
              disabled={!checkValue}
            />
          </div>
        </Grid>
        <SdmSpacer height={isSmDown ? 30 : 90} />
      </Grid>
    </form>
  );
};
export { BookingUser };
